// src/features/chat/components/ImageUploader.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';

const ImageUploader = ({
  onFilesSelected,
  fileInputRef,
  accept = 'image/*',
  multiple = true,
  ariaLabel,
}) => {
  const { t } = useTranslation();

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    onFilesSelected?.(selectedFiles);

    // Reset the file input value to allow re-uploading the same file if needed
    event.target.value = '';
  };

  return (
    <input
      type="file"
      ref={fileInputRef}
      onChange={handleFileChange}
      accept={accept}
      multiple={multiple}
      style={{ display: 'none' }}
      aria-label={ariaLabel || t('chat.upload_images')}
    />
  );
};

export default ImageUploader;
